import { useQuery } from "@tanstack/react-query";
import { getNotifications } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const NOTIFICATIONS_QUERY_KEY = "NOTIFICATIONS";

export const notificationsKeys = {
  all: [NOTIFICATIONS_QUERY_KEY],
  list: (unseenOnly: boolean, page: number, pageSize: number) => [
    ...notificationsKeys.all,
    { unseenOnly, page, pageSize },
  ],
};

export const useNotifications = (unseenOnly = false, page = 1, pageSize = 50) =>
  useQuery({
    queryKey: notificationsKeys.list(unseenOnly, page, pageSize),
    queryFn: processResponseWithApiProblemDetails(() =>
      getNotifications(unseenOnly, page, pageSize),
    ),
    refetchOnWindowFocus: false,
  });
